<ng-template>
  <div class="wrapper" [ngClass]="{ end: align === 'end' }">
    <span class="toggle-label" *ngIf="inlineLabel" [id]="labelId" [ngClass]="{ grayed: !formControl.value }">{{ labelText }}</span>
    <ui-toggle [formControl]="formControl" [uiId]="controlId" [disabled]="disabled" [attr.data-test-id]="e2eTestId" [labelledby]="labelId"></ui-toggle>
  </div>
</ng-template>
